import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    background: theme.palette.custom.background.area,

    '& .schedule-slot-controls': {
      '&-container': {
        minWidth: theme.spacing(18),
        maxWidth: theme.spacing(18),
        height: theme.spacing(6) + 1,
        display: 'flex',
        flexDirection: 'column',
      },

      '&-content': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        borderRight: `solid 1px ${theme.palette.divider}`,
        borderBottom: `solid 1px ${theme.palette.divider}`,
        overflow: 'hidden',
      },
    },

    '& .swiper-header': {
      '&-wrapper': {
        display: 'flex',
        flexGrow: 1,
        overflow: 'hidden',
      },
      '&-container': {
        display: 'flex',
        flexGrow: 1,
        width: '100%',
      },
      '&-column': {
        '&-container': {
          display: 'flex',
          width: '100%',
        },
        '&-content': {
          display: 'flex',
          alignItems: 'flex-end',
          width: '100%',
          borderRight: `solid 1px ${theme.palette.divider}`,
        },
      },
    },
  },
}));

export default styles;
